function hideGalleryIfEmpty() {
  var gallerySection = document.querySelector('.single [data-date]');
  if (!gallerySection) return;
  var gallery = gallerySection === null || gallerySection === void 0 ? void 0 : gallerySection.querySelector('.elementor-gallery__container');
  var postDate = new Date((gallerySection === null || gallerySection === void 0 ? void 0 : gallerySection.dataset.date) * 1000);
  if (!postDate) return;
  var today = new Date();
  if (!gallery || postDate > today) {
    gallerySection.remove();
  }
}
function hideAlbumIfEmpty() {
  var albumSection = document.querySelector('.page [data-date]');
  if (!albumSection) return;
  var album = albumSection === null || albumSection === void 0 ? void 0 : albumSection.querySelector('.elementor-portfolio');
  var postDate = new Date((albumSection === null || albumSection === void 0 ? void 0 : albumSection.dataset.date) * 1000);
  if (!postDate) return;
  var today = new Date();
  if (!album || postDate > today) {
    albumSection.remove();
  }
}
export default function initEvents() {
  hideGalleryIfEmpty();
}